/* Оригинал: http://stackoverflow.com/a/11268104 */
export function scorePassword(pass?: string) {
  const trimmedPass = pass?.trim();
  let score = 0;
  if (!trimmedPass) {
    return score;
  }

  // Прибавляем за каждую уникальную до пяти повторений букву
  const letters: Record<string, number> = {};
  for (let i = 0; i < trimmedPass.length; i++) {
    letters[trimmedPass[i]] = (letters[trimmedPass[i]] || 0) + 1;
    score += 5 / letters[trimmedPass[i]];
  }

  let variationCount = 0;
  // Если содержит число, добавляем промежуточное очко
  if (/\d/.test(trimmedPass)) {
    variationCount++;
  }
  // Если содержит символ в нижнем регистре, добавляем промежуточное очко
  if (/[a-z]/.test(trimmedPass)) {
    variationCount++;
  }
  // Если содержит символ в верхнем регистре, добавляем промежуточное очко
  if (/[A-Z]/.test(trimmedPass)) {
    variationCount++;
  }
  // Если содержит спец. символ, добавляем промежуточное очко
  if (/\W/.test(trimmedPass)) {
    variationCount++;
  }
  score += (variationCount - 1) * 10;

  return score;
}

/**
 * @description Требования к паролю:
 * Длина не менее 10 символов
 * Должен содержать символы в верхнем и нижнем регистре
 * Должен содержать цифры и специальные символы: !?@#$%^&*_-~<>/|
 *
 * @see http://stackoverflow.com/a/11268104
 */
export function passIsGood(pass: string) {
  return scorePassword(pass) > 85;
}
